import { buildSlice, CommonState } from '~libs/reduxUtils';

import { getAll, typePrefix } from '~lookups/actions/userLanguages';
import { UserLanguage } from '~lookups/models';

const initialState: CommonState<UserLanguage> = {
  loading: 'idle',
  error: null,
  rows: [],
  hasLoaded: false,
};

const userLanguagesSlice = buildSlice<CommonState<UserLanguage>, UserLanguage>(typePrefix, initialState, {
  commonConfig: { getAll },
});

export default userLanguagesSlice.reducer;
